
import { DOMAIN_CONFIG, IS_LOCALHOST, isSaaSPlatform, isStandaloneStudio } from '../config/domainConfig';

/**
 * Global App Configuration based on Domain
 * Allows the same codebase to run as "Janoobi Studio" (.com), "Janoobi Marketplace" (.app), or "Portal"
 */

export const getAppMode = (): 'STUDIO' | 'MARKETPLACE' | 'PORTAL' => {
    // 1. Check Build-Time Flag (For Production Deployment)
    const buildMode = (import.meta as any).env.VITE_APP_MODE;
    
    // 2. Runtime Domain Check (Overrides build flag for hybrid deployments)
    const hostname = window.location.hostname;

    // MARKETPLACE / LANDING / ADMIN
    if (isSaaSPlatform(hostname)) {
        return 'MARKETPLACE';
    }

    // PORTAL GATEWAY (Exact Match of Base)
    // e.g. portal.janoobistudios.com -> Shows Login/Find Workspace only
    if (hostname === DOMAIN_CONFIG.SAAS_PORTAL_BASE || hostname === `portal.janoobistudios.com` || hostname === 'portal.saas.janoobistudios.com' || hostname === 'saas.janoobistudios.com' && window.location.pathname.includes('/portal')) {
        return 'PORTAL';
    }

    // TENANT STUDIO (Subdomain or Custom)
    // e.g. neon.s.janoobistudios.com OR mystudio.com
    if (
        hostname.endsWith(`.${DOMAIN_CONFIG.SAAS_PORTAL_BASE}`) ||
        hostname.includes('janoobi-portal') ||
        isStandaloneStudio(hostname)
    ) {
        return 'STUDIO';
    }

    // Localhost Development
    if (IS_LOCALHOST) {
        if (buildMode === 'SAAS') return 'MARKETPLACE';
        if (buildMode === 'PORTAL') return 'PORTAL'; 
        return 'STUDIO';
    }

    // Default Fallback (Custom Domains)
    return 'STUDIO';
};

export const isStripeEnabled = (): boolean => {
    return getAppMode() === 'STUDIO';
};

export const getAppTitle = (): string => {
    const mode = getAppMode();
    const hostname = window.location.hostname;
    
    if (mode === 'MARKETPLACE') return 'Janoobi Studios Marketplace';
    if (mode === 'PORTAL') return 'Janoobi Studios Portal';
    if (isStandaloneStudio(hostname)) return 'Janoobi Studios';
    
    return 'Studio Portal';
};
